import {
  initMetadataForCompanion1wyw17z38v6ac as initMetadataForCompanion,
  initMetadataForObject1cxne3s9w65el as initMetadataForObject,
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { PluginGeneratedSerialDescriptorqdzeg5asqhfg as PluginGeneratedSerialDescriptor } from '../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/internal/PluginGeneratedSerialDescriptor.mjs';
import { LocalDateSerializer_getInstance3qg2c8779i3ej as LocalDateSerializer_getInstance } from '../../../../../Kotlin-DateTime-library-kotlinx-datetime/kotlinx/datetime/serializers/LocalDateSerializers.mjs';
import { Unit_instance3kz1zqli6gr1r as Unit_instance } from '../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { BooleanSerializer_getInstance22aja3hu17sxf as BooleanSerializer_getInstance } from '../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/internal/Primitives.mjs';
import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { UnknownFieldExceptiona60e3a6v1xqo as UnknownFieldException } from '../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/SerializationExceptions.mjs';
import { get_nullable197rfua9r7fsz as get_nullable } from '../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/builtins/BuiltinSerializers.mjs';
import {
  typeParametersSerializers2likxjr48tr7y as typeParametersSerializers,
  GeneratedSerializer1f7t7hssdd2ws as GeneratedSerializer,
} from '../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/internal/PluginHelperInterfaces.mjs';
import {
  protoOf180f3jzyo7rfj as protoOf,
  getBooleanHashCode1bbj3u6b3v0a7 as getBooleanHashCode,
  equals2au1ep9vhcato as equals,
  createThis2j2avj17cvnv2 as createThis,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import {
  Always_getInstance177eud73uc475 as Always_getInstance,
  And1a3dbpwh0hxmu as And,
} from '../../../../../service-abstractions-database-shared/com/lightningkite/services/database/Condition.mjs';
import { Notification1y91jemwm75tr as Notification } from '../../../../../lightning-server-notifications-shared/com/lightningkite/lightningserver/notifications/notificationModels.mjs';
import { getKClass3t8tygqu4lcxf as getKClass } from '../../../../../kotlin-kotlin-stdlib/kotlin/reflect/js/internal/reflection.mjs';
import { ID2ebczrc12h07k as ID } from '../../../../../tcg-cares-shared/org/thecommunitygroupinc/cares/models.mjs';
import {
  arrayOf1akklvh2at202 as arrayOf,
  toString30pk9tzaqopn as toString,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/Library.mjs';
import {
  createKType31ecntyyaay3k as createKType,
  createInvariantKTypeProjection3h5364czc0a8w as createInvariantKTypeProjection,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/reflect/js/internal/KTypeHelpers.mjs';
import { TCGNotification15rsix3sbs9g0 as TCGNotification } from '../../../../../tcg-cares-shared/org/thecommunitygroupinc/cares/notifications.mjs';
import { serializerOrContextual2mm942ha7plg6 as serializerOrContextual } from '../../../../../service-abstractions-database-shared/com/lightningkite/services/database/SerializationHelpers.mjs';
import { KSerializerzf77vz1967fq as KSerializer } from '../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/KSerializer.mjs';
import { isInterface3d6p8outrmvmk as isInterface } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/typeCheckUtils.mjs';
import { DataClassPathSelf18kqeagzkbefr as DataClassPathSelf } from '../../../../../service-abstractions-database-shared/com/lightningkite/services/database/DataClassPath.mjs';
import {
  get_createdAt1oxi5pjv9saww as get_createdAt,
  get_read2fqnxj4c930ns as get_read,
} from '../../../../../lightning-server-notifications-shared/com/lightningkite/lightningserver/notifications/ModelFields-2090458501.mjs';
import { get_TCG_TIME_ZONEb89pisv39t5w as get_TCG_TIME_ZONE } from '../../../../../tcg-cares-shared/org/thecommunitygroupinc/cares/clock.mjs';
import { atStartOfDayInq85k5urxn794 as atStartOfDayIn } from '../../../../../Kotlin-DateTime-library-kotlinx-datetime/kotlinx/datetime/TimeZone.mjs';
import {
  gte1zw995v5ulf70 as gte,
  lt30kf68e33bhtj as lt,
  eq353yrgcpovoi1 as eq,
  neqpgb3jcwulnab as neq,
} from '../../../../../service-abstractions-database-shared/com/lightningkite/services/database/ConditionBuilder.mjs';
import { DatePeriod2y4m7pf19ebgd as DatePeriod } from '../../../../../Kotlin-DateTime-library-kotlinx-datetime/kotlinx/datetime/DateTimePeriod.mjs';
import { plus1oi9f9vif99u2 as plus } from '../../../../../Kotlin-DateTime-library-kotlinx-datetime/kotlinx/datetime/LocalDate.mjs';
import {
  listOfNotNull2woi2boe01ub4 as listOfNotNull,
  listOf1jh22dvmctj1r as listOf,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/CollectionsKt.mjs';
import { throwMissingFieldException2cmke0v3ynf14 as throwMissingFieldException } from '../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/internal/PluginExceptions.mjs';
import { RowOrCol3a33s3yce2tuv as RowOrCol } from '../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/LinearLayouts.commonHtml.mjs';
import { ensureOutermostElement1f4fzdv7yw0ql as ensureOutermostElement } from '../../../../../kiteui-library/com/lightningkite/kiteui/views/NativeElement.mjs';
import {
  weight31wqab1913ly4 as weight,
  shownWhen3t7othivfr11 as shownWhen,
} from '../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/modifiers.commonHtml.mjs';
import { LabeledViewseav57tyecmf as LabeledView } from '../../../../../kiteui-library/com/lightningkite/kiteui/views/l2/labels.mjs';
import {
  FieldSemantic_getInstancer1p3l15xmphu as FieldSemantic_getInstance,
  ListSemantic_getInstance2e62q1se6gw64 as ListSemantic_getInstance,
} from '../../../../../kiteui-library/com/lightningkite/kiteui/models/Theme.mjs';
import { themed2vu67ornd4jps as themed } from '../../../../../kiteui-library/com/lightningkite/kiteui/views/themeDerivations.mjs';
import { LocalDateField1854369auhx0q as LocalDateField } from '../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/LocalDateTimeField.commonHtml.mjs';
import { Select2osqjs95yxuh6 as Select } from '../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/Select.commonHtml.mjs';
import {
  _Constant___init__impl__v45mub2qfk15kh5l39c as _Constant___init__impl__v45mub,
  Constant3smypj7m9af27 as Constant,
} from '../../../../../reactive/com/lightningkite/reactive/core/signals.mjs';
import {
  filterMenu2fz1h01y9a2vu as filterMenu,
  FilterChiptjf5vayz5x4r as FilterChip,
  filterChip1bkihjb9h4931 as filterChip,
} from './components/filters.mjs';
import { ArrayList3it5z8td81qkl as ArrayList } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/ArrayListJs.mjs';
import { RenderSize_Abbreviation_getInstance3svlv9et1kjyg as RenderSize_Abbreviation_getInstance } from '../../../../../kiteui-library/com/lightningkite/kiteui/locale/LocalTimeRender.mjs';
import { renderToString2kyj9dlz89tdi as renderToString } from '../../../../../kiteui-library/com/lightningkite/kiteui/locale/LocalTimeRender.js.mjs';
import { remember2m0mx1b5ra75q as remember } from '../../../../../reactive/com/lightningkite/reactive/core/Remember.mjs';
import { ScrollingBehaviorImpl35p8dxbs74spr as ScrollingBehaviorImpl } from '../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/ScrollView.commonHtml.js.mjs';
import { beforeSetup1a13mbd699ddp as beforeSetup } from '../../../../../kiteui-library/com/lightningkite/kiteui/views/ElementWriter.ext.mjs';
import { rowOf3phwx1yo72ntt as rowOf } from '../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/lists.mjs';
import { orPromise1iucc2to2udt2 as orPromise } from '../../../../../kotlin-kotlin-stdlib/kotlin/coroutines/intrinsics/coroutinesInteropJs.mjs';
import { constructCallableReference23y65rf941mch as constructCallableReference } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/reflectRuntime.mjs';
import { modify3w2ijgzr8982m as modify } from '../../../../../reactive/com/lightningkite/reactive/extensions/helpers.mjs';
import { to2cs3ny02qtbcb as to } from '../../../../../kotlin-kotlin-stdlib/kotlin/Tuples.mjs';
import { get_centered31th09q7x90sf as get_centered } from '../../../../../kiteui-library/com/lightningkite/kiteui/views/helpers.mjs';
import { lens27v59dqa1oc3r as lens } from '../../../../../reactive/com/lightningkite/reactive/lensing/abstracts.mjs';
import { await1uwe8zvsjq69o as await_0 } from '../../../../../reactive/com/lightningkite/reactive/context/DependencyChangeListener.mjs';
import { SerializableWithd2dap36updxd as SerializableWith } from '../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/SerializersJs.mjs';
//region block: imports
var imul = Math.imul;
//endregion
//region block: pre-declaration
//endregion
var CompanionClass;
function Companion() {
  if (CompanionClass === VOID) {
    class $ {}
    initMetadataForCompanion($);
    CompanionClass = $;
  }
  return CompanionClass;
}
var Companion_instance;
function Companion_getInstance() {
  return Companion_instance;
}
var $serializerClass;
function $serializer() {
  if ($serializerClass === VOID) {
    class $ {
      constructor() {
        $serializer_instance = this;
        var tmp0_serialDesc = new (PluginGeneratedSerialDescriptor())('org.thecommunitygroupinc.cares.views.NotificationFilters', this, 3);
        tmp0_serialDesc.addElement_5pzumi_k$('receivedAfter', true);
        tmp0_serialDesc.addElement_5pzumi_k$('receivedBefore', true);
        tmp0_serialDesc.addElement_5pzumi_k$('read', true);
        this.descriptor_1 = tmp0_serialDesc;
      }
      serialize_85fss7_k$(encoder, value) {
        var tmp0_desc = this.descriptor_1;
        var tmp1_output = encoder.beginStructure_yljocp_k$(tmp0_desc);
        if (tmp1_output.shouldEncodeElementDefault_x8eyid_k$(tmp0_desc, 0) ? true : !(value.receivedAfter_1 == null)) {
          tmp1_output.encodeNullableSerializableElement_5lquiv_k$(tmp0_desc, 0, LocalDateSerializer_getInstance(), value.receivedAfter_1);
        }
        if (tmp1_output.shouldEncodeElementDefault_x8eyid_k$(tmp0_desc, 1) ? true : !(value.receivedBefore_1 == null)) {
          tmp1_output.encodeNullableSerializableElement_5lquiv_k$(tmp0_desc, 1, LocalDateSerializer_getInstance(), value.receivedBefore_1);
        }
        if (tmp1_output.shouldEncodeElementDefault_x8eyid_k$(tmp0_desc, 2) ? true : !(value.read_1 == null)) {
          tmp1_output.encodeNullableSerializableElement_5lquiv_k$(tmp0_desc, 2, BooleanSerializer_getInstance(), value.read_1);
        }
        tmp1_output.endStructure_1xqz0n_k$(tmp0_desc);
      }
      serialize_5ase3y_k$(encoder, value) {
        return this.serialize_85fss7_k$(encoder, value instanceof NotificationFilters() ? value : THROW_CCE());
      }
      deserialize_sy6x50_k$(decoder) {
        var tmp0_desc = this.descriptor_1;
        var tmp1_flag = true;
        var tmp2_index = 0;
        var tmp3_bitMask0 = 0;
        var tmp4_local0 = null;
        var tmp5_local1 = null;
        var tmp6_local2 = null;
        var tmp7_input = decoder.beginStructure_yljocp_k$(tmp0_desc);
        if (tmp7_input.decodeSequentially_xlblqy_k$()) {
          tmp4_local0 = tmp7_input.decodeNullableSerializableElement_k2y6ab_k$(tmp0_desc, 0, LocalDateSerializer_getInstance(), tmp4_local0);
          tmp3_bitMask0 = tmp3_bitMask0 | 1;
          tmp5_local1 = tmp7_input.decodeNullableSerializableElement_k2y6ab_k$(tmp0_desc, 1, LocalDateSerializer_getInstance(), tmp5_local1);
          tmp3_bitMask0 = tmp3_bitMask0 | 2;
          tmp6_local2 = tmp7_input.decodeNullableSerializableElement_k2y6ab_k$(tmp0_desc, 2, BooleanSerializer_getInstance(), tmp6_local2);
          tmp3_bitMask0 = tmp3_bitMask0 | 4;
        } else
          while (tmp1_flag) {
            tmp2_index = tmp7_input.decodeElementIndex_bstkhp_k$(tmp0_desc);
            switch (tmp2_index) {
              case -1:
                tmp1_flag = false;
                break;
              case 0:
                tmp4_local0 = tmp7_input.decodeNullableSerializableElement_k2y6ab_k$(tmp0_desc, 0, LocalDateSerializer_getInstance(), tmp4_local0);
                tmp3_bitMask0 = tmp3_bitMask0 | 1;
                break;
              case 1:
                tmp5_local1 = tmp7_input.decodeNullableSerializableElement_k2y6ab_k$(tmp0_desc, 1, LocalDateSerializer_getInstance(), tmp5_local1);
                tmp3_bitMask0 = tmp3_bitMask0 | 2;
                break;
              case 2:
                tmp6_local2 = tmp7_input.decodeNullableSerializableElement_k2y6ab_k$(tmp0_desc, 2, BooleanSerializer_getInstance(), tmp6_local2);
                tmp3_bitMask0 = tmp3_bitMask0 | 4;
                break;
              default:
                throw UnknownFieldException().new_kotlinx_serialization_UnknownFieldException_ecrf7z_k$(tmp2_index);
            }
          }
        tmp7_input.endStructure_1xqz0n_k$(tmp0_desc);
        return NotificationFilters().new_org_thecommunitygroupinc_cares_views_NotificationFilters_qhxwy4_k$(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, null);
      }
      get_descriptor_wjt6a0_k$() {
        return this.descriptor_1;
      }
      childSerializers_5ghqw5_k$() {
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        return [get_nullable(LocalDateSerializer_getInstance()), get_nullable(LocalDateSerializer_getInstance()), get_nullable(BooleanSerializer_getInstance())];
      }
    }
    protoOf($).typeParametersSerializers_fr94fx_k$ = typeParametersSerializers;
    initMetadataForObject($, '$serializer', VOID, VOID, [GeneratedSerializer()]);
    $serializerClass = $;
  }
  return $serializerClass;
}
var $serializer_instance;
function $serializer_getInstance() {
  if ($serializer_instance === VOID)
    new ($serializer())();
  return $serializer_instance;
}
var NotificationFiltersClass;
function NotificationFilters() {
  if (NotificationFiltersClass === VOID) {
    class $ {
      constructor(receivedAfter, receivedBefore, read) {
        receivedAfter = receivedAfter === VOID ? null : receivedAfter;
        receivedBefore = receivedBefore === VOID ? null : receivedBefore;
        read = read === VOID ? null : read;
        this.receivedAfter_1 = receivedAfter;
        this.receivedBefore_1 = receivedBefore;
        this.read_1 = read;
      }
      toCondition_oj74tc_k$() {
        var tmp = Always_getInstance();
        var tmp0_safe_receiver = this.receivedAfter_1;
        var tmp_0;
        if (tmp0_safe_receiver == null) {
          tmp_0 = null;
        } else {
          // Inline function 'kotlin.let' call
          // Inline function 'com.lightningkite.services.database.condition' call
          // Inline function 'com.lightningkite.services.database.path' call
          // Inline function 'com.lightningkite.services.database.serializerOrContextual' call
          var tmp_1 = serializerOrContextual(createKType(getKClass(Notification()), arrayOf([createInvariantKTypeProjection(createKType(getKClass(ID()), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(TCGNotification()), arrayOf([]), false))]), false));
          var tmp$ret$4 = isInterface(tmp_1, KSerializer()) ? tmp_1 : THROW_CCE();
          // Inline function 'kotlin.let' call
          var it = new (DataClassPathSelf())(tmp$ret$4);
          tmp_0 = gte(get_createdAt(it), atStartOfDayIn(tmp0_safe_receiver, get_TCG_TIME_ZONE()));
        }
        var tmp_2 = tmp_0;
        var tmp1_safe_receiver = this.receivedBefore_1;
        var tmp_3;
        if (tmp1_safe_receiver == null) {
          tmp_3 = null;
        } else {
          // Inline function 'kotlin.let' call
          // Inline function 'com.lightningkite.services.database.condition' call
          // Inline function 'com.lightningkite.services.database.path' call
          // Inline function 'com.lightningkite.services.database.serializerOrContextual' call
          var tmp_4 = serializerOrContextual(createKType(getKClass(Notification()), arrayOf([createInvariantKTypeProjection(createKType(getKClass(ID()), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(TCGNotification()), arrayOf([]), false))]), false));
          var tmp$ret$11 = isInterface(tmp_4, KSerializer()) ? tmp_4 : THROW_CCE();
          // Inline function 'kotlin.let' call
          var it_0 = new (DataClassPathSelf())(tmp$ret$11);
          tmp_3 = lt(get_createdAt(it_0), atStartOfDayIn(plus(tmp1_safe_receiver, DatePeriod().new_kotlinx_datetime_DatePeriod_19p8ip_k$(VOID, VOID, 1)), get_TCG_TIME_ZONE()));
        }
        var tmp_5 = tmp_3;
        var tmp2_safe_receiver = this.read_1;
        var tmp_6;
        if (tmp2_safe_receiver == null) {
          tmp_6 = null;
        } else {
          // Inline function 'kotlin.let' call
          var tmp_7;
          if (tmp2_safe_receiver) {
            // Inline function 'com.lightningkite.services.database.condition' call
            // Inline function 'com.lightningkite.services.database.path' call
            // Inline function 'com.lightningkite.services.database.serializerOrContextual' call
            var tmp_8 = serializerOrContextual(createKType(getKClass(Notification()), arrayOf([createInvariantKTypeProjection(createKType(getKClass(ID()), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(TCGNotification()), arrayOf([]), false))]), false));
            var tmp$ret$18 = isInterface(tmp_8, KSerializer()) ? tmp_8 : THROW_CCE();
            // Inline function 'kotlin.let' call
            var it_1 = new (DataClassPathSelf())(tmp$ret$18);
            tmp_7 = neq(get_read(it_1), null);
          } else {
            // Inline function 'com.lightningkite.services.database.condition' call
            // Inline function 'com.lightningkite.services.database.path' call
            // Inline function 'com.lightningkite.services.database.serializerOrContextual' call
            var tmp_9 = serializerOrContextual(createKType(getKClass(Notification()), arrayOf([createInvariantKTypeProjection(createKType(getKClass(ID()), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(TCGNotification()), arrayOf([]), false))]), false));
            var tmp$ret$23 = isInterface(tmp_9, KSerializer()) ? tmp_9 : THROW_CCE();
            // Inline function 'kotlin.let' call
            var it_2 = new (DataClassPathSelf())(tmp$ret$23);
            tmp_7 = eq(get_read(it_2), null);
          }
          tmp_6 = tmp_7;
        }
        return And().new_com_lightningkite_services_database_Condition_And_6mqlxl_k$(listOfNotNull([tmp, tmp_2, tmp_5, tmp_6]));
      }
      activeCount_htest3_k$() {
        var count = 0;
        if (!(this.receivedAfter_1 == null)) {
          count = count + 1 | 0;
        }
        if (!(this.receivedBefore_1 == null)) {
          count = count + 1 | 0;
        }
        if (!(this.read_1 == null)) {
          count = count + 1 | 0;
        }
        return count;
      }
      copy_7mw2t7_k$(receivedAfter, receivedBefore, read) {
        return new (NotificationFilters())(receivedAfter, receivedBefore, read);
      }
      copy$default_t9hy7s_k$(receivedAfter, receivedBefore, read, $super) {
        receivedAfter = receivedAfter === VOID ? this.receivedAfter_1 : receivedAfter;
        receivedBefore = receivedBefore === VOID ? this.receivedBefore_1 : receivedBefore;
        read = read === VOID ? this.read_1 : read;
        return $super === VOID ? this.copy_7mw2t7_k$(receivedAfter, receivedBefore, read) : $super.copy_7mw2t7_k$.call(this, receivedAfter, receivedBefore, read);
      }
      toString() {
        return 'NotificationFilters(receivedAfter=' + toString(this.receivedAfter_1) + ', receivedBefore=' + toString(this.receivedBefore_1) + ', read=' + this.read_1 + ')';
      }
      hashCode() {
        var result = this.receivedAfter_1 == null ? 0 : this.receivedAfter_1.hashCode();
        result = imul(result, 31) + (this.receivedBefore_1 == null ? 0 : this.receivedBefore_1.hashCode()) | 0;
        result = imul(result, 31) + (this.read_1 == null ? 0 : getBooleanHashCode(this.read_1)) | 0;
        return result;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof NotificationFilters()))
          return false;
        if (!equals(this.receivedAfter_1, other.receivedAfter_1))
          return false;
        if (!equals(this.receivedBefore_1, other.receivedBefore_1))
          return false;
        if (!(this.read_1 == other.read_1))
          return false;
        return true;
      }
      static new_org_thecommunitygroupinc_cares_views_NotificationFilters_qhxwy4_k$(seen0, receivedAfter, receivedBefore, read, serializationConstructorMarker) {
        if (!(0 === (0 & seen0))) {
          throwMissingFieldException(seen0, 0, $serializer_getInstance().descriptor_1);
        }
        var $this = createThis(this);
        if (0 === (seen0 & 1))
          $this.receivedAfter_1 = null;
        else
          $this.receivedAfter_1 = receivedAfter;
        if (0 === (seen0 & 2))
          $this.receivedBefore_1 = null;
        else
          $this.receivedBefore_1 = receivedBefore;
        if (0 === (seen0 & 4))
          $this.read_1 = null;
        else
          $this.read_1 = read;
        return $this;
      }
    }
    initMetadataForClass($, 'NotificationFilters', NotificationFilters, VOID, VOID, VOID, VOID, {0: $serializer_getInstance});
    NotificationFiltersClass = $;
  }
  return NotificationFiltersClass;
}
function notificationFilters(_this__u8e3s4, target) {
  var tmp = notificationFilters$slambda(target);
  return filterMenu(_this__u8e3s4, target, tmp, ($this$filterMenu) => {
    // Inline function 'com.lightningkite.kiteui.views.direct.row' call
    // Inline function 'com.lightningkite.kiteui.views.write' call
    var element = new (RowOrCol())($this$filterMenu.get_context_h02k06_k$());
    ensureOutermostElement(element);
    $this$filterMenu.willAddChild_hz2iwc_k$(element);
    element.set_vertical_nuap32_k$(false);
    // Inline function 'com.lightningkite.kiteui.views.expanding' call
    var tmp0 = weight(element, 1.0);
    // Inline function 'com.lightningkite.kiteui.views.l2.label' call
    var label = 'Received after';
    // Inline function 'com.lightningkite.kiteui.views.l2.label' call
    // Inline function 'com.lightningkite.kiteui.views.write' call
    var element_0 = LabeledView().new_com_lightningkite_kiteui_views_l2_LabeledView_y9e4ty_k$(tmp0.get_context_h02k06_k$());
    ensureOutermostElement(element_0);
    tmp0.willAddChild_hz2iwc_k$(element_0);
    element_0.set_content_lzqutq_k$(label);
    // Inline function 'com.lightningkite.kiteui.views.fieldTheme' call
    // Inline function 'com.lightningkite.kiteui.views.direct.localDateField' call
    var this_0 = themed(element_0, FieldSemantic_getInstance());
    // Inline function 'com.lightningkite.kiteui.views.write' call
    var element_1 = new (LocalDateField())(this_0.get_context_h02k06_k$());
    ensureOutermostElement(element_1);
    this_0.willAddChild_hz2iwc_k$(element_1);
    var tmp = notificationFilters$lambda$lambda;
    element_1.bind_gesskf_k$(element_1.content_1, target.lens_u4wb4z_k$(tmp, notificationFilters$lambda$lambda_0));
    element_1.onStartup_vrxh3i_k$();
    this_0.addChild_2qpft2_k$(element_1);
    element_0.onStartup_vrxh3i_k$();
    tmp0.addChild_2qpft2_k$(element_0);
    // Inline function 'com.lightningkite.kiteui.views.expanding' call
    var tmp0_0 = weight(element, 1.0);
    // Inline function 'com.lightningkite.kiteui.views.l2.label' call
    var label_0 = 'Received before';
    // Inline function 'com.lightningkite.kiteui.views.l2.label' call
    // Inline function 'com.lightningkite.kiteui.views.write' call
    var element_2 = LabeledView().new_com_lightningkite_kiteui_views_l2_LabeledView_y9e4ty_k$(tmp0_0.get_context_h02k06_k$());
    ensureOutermostElement(element_2);
    tmp0_0.willAddChild_hz2iwc_k$(element_2);
    element_2.set_content_lzqutq_k$(label_0);
    // Inline function 'com.lightningkite.kiteui.views.fieldTheme' call
    // Inline function 'com.lightningkite.kiteui.views.direct.localDateField' call
    var this_1 = themed(element_2, FieldSemantic_getInstance());
    // Inline function 'com.lightningkite.kiteui.views.write' call
    var element_3 = new (LocalDateField())(this_1.get_context_h02k06_k$());
    ensureOutermostElement(element_3);
    this_1.willAddChild_hz2iwc_k$(element_3);
    var tmp_0 = notificationFilters$lambda$lambda_1;
    element_3.bind_gesskf_k$(element_3.content_1, target.lens_u4wb4z_k$(tmp_0, notificationFilters$lambda$lambda_2));
    element_3.onStartup_vrxh3i_k$();
    this_1.addChild_2qpft2_k$(element_3);
    element_2.onStartup_vrxh3i_k$();
    tmp0_0.addChild_2qpft2_k$(element_2);
    element.onStartup_vrxh3i_k$();
    $this$filterMenu.addChild_2qpft2_k$(element);
    // Inline function 'com.lightningkite.kiteui.views.l2.label' call
    // Inline function 'com.lightningkite.kiteui.views.l2.label' call
    // Inline function 'com.lightningkite.kiteui.views.write' call
    var element_4 = LabeledView().new_com_lightningkite_kiteui_views_l2_LabeledView_y9e4ty_k$($this$filterMenu.get_context_h02k06_k$());
    ensureOutermostElement(element_4);
    $this$filterMenu.willAddChild_hz2iwc_k$(element_4);
    element_4.set_content_lzqutq_k$('Read');
    // Inline function 'com.lightningkite.kiteui.views.fieldTheme' call
    // Inline function 'com.lightningkite.kiteui.views.direct.row' call
    var this_2 = themed(element_4, FieldSemantic_getInstance());
    // Inline function 'com.lightningkite.kiteui.views.write' call
    var element_5 = new (RowOrCol())(this_2.get_context_h02k06_k$());
    ensureOutermostElement(element_5);
    this_2.willAddChild_hz2iwc_k$(element_5);
    element_5.set_vertical_nuap32_k$(false);
    // Inline function 'com.lightningkite.kiteui.views.expanding' call
    // Inline function 'com.lightningkite.kiteui.views.direct.select' call
    var this_3 = weight(element_5, 1.0);
    // Inline function 'com.lightningkite.kiteui.views.write' call
    var element_6 = new (Select())(this_3.get_context_h02k06_k$());
    ensureOutermostElement(element_6);
    this_3.willAddChild_hz2iwc_k$(element_6);
    var tmp_1 = notificationFilters$lambda$lambda_3;
    var tmp_2 = target.lens_u4wb4z_k$(tmp_1, notificationFilters$lambda$lambda_4);
    var tmp_3 = _Constant___init__impl__v45mub(listOf([null, true, false]));
    element_6.bind_64a41i_k$(tmp_2, new (Constant())(tmp_3), notificationFilters$lambda$lambda_5);
    element_6.onStartup_vrxh3i_k$();
    this_3.addChild_2qpft2_k$(element_6);
    element_5.onStartup_vrxh3i_k$();
    this_2.addChild_2qpft2_k$(element_5);
    element_4.onStartup_vrxh3i_k$();
    $this$filterMenu.addChild_2qpft2_k$(element_4);
    return Unit_instance;
  });
}
function notificationFilterChips(_this__u8e3s4, filter) {
  var chips = remember(VOID, VOID, VOID, VOID, ($this$remember) => {
    // Inline function 'kotlin.collections.buildList' call
    // Inline function 'kotlin.collections.buildListInternal' call
    // Inline function 'kotlin.apply' call
    var this_0 = ArrayList().new_kotlin_collections_ArrayList_ony0vx_k$();
    var tmp0_safe_receiver = $this$remember.invoke_r7m7el_k$(filter).receivedAfter_1;
    if (tmp0_safe_receiver == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      var tmp = 'Received after: ' + renderToString(tmp0_safe_receiver, RenderSize_Abbreviation_getInstance());
      this_0.add_utx5q5_k$(new (FilterChip())(tmp0_safe_receiver, tmp, notificationFilterChips$lambda$slambda(filter)));
    }
    var tmp1_safe_receiver = $this$remember.invoke_r7m7el_k$(filter).receivedBefore_1;
    if (tmp1_safe_receiver == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      var tmp_0 = 'Received before: ' + renderToString(tmp1_safe_receiver, RenderSize_Abbreviation_getInstance());
      this_0.add_utx5q5_k$(new (FilterChip())(tmp1_safe_receiver, tmp_0, notificationFilterChips$lambda$slambda_0(filter)));
    }
    var tmp2_safe_receiver = $this$remember.invoke_r7m7el_k$(filter).read_1;
    if (tmp2_safe_receiver == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      var tmp_1 = tmp2_safe_receiver ? 'Read' : 'Unread';
      this_0.add_utx5q5_k$(new (FilterChip())(tmp2_safe_receiver, tmp_1, notificationFilterChips$lambda$slambda_1(filter)));
    }
    return this_0.build_nmwvly_k$();
  });
  // Inline function 'com.lightningkite.kiteui.views.direct.scrollingHorizontally' call
  // Inline function 'com.lightningkite.kiteui.views.direct.__scrollsUncontracted' call
  var this_0 = themed(shownWhen(_this__u8e3s4, VOID, VOID, ($this$shownWhen) => {
    // Inline function 'kotlin.collections.isNotEmpty' call
    return !$this$shownWhen.invoke_r7m7el_k$(chips).isEmpty_y1axqb_k$();
  }), ListSemantic_getInstance());
  var vertical = false;
  var horizontal = true;
  var tmp = beforeSetup(this_0, ($this$beforeSetup) => {
    (new (ScrollingBehaviorImpl())($this$beforeSetup, horizontal, vertical)).set_showScrollBars_vutwwi_k$(false);
    return Unit_instance;
  });
  var tmp_0 = notificationFilterChips$lambda;
  var tmp_1 = notificationFilterChips$lambda_0;
  rowOf(tmp, chips, tmp_0, VOID, tmp_1, notificationFilterChips$lambda_1);
}
function notificationFilters$slambda($target) {
  return constructCallableReference(($completion) => orPromise($completion, function *($completion) {
    yield* $target.set_revjhg_k$(new (NotificationFilters())(), $completion);
    return Unit_instance;
  }), 0);
}
function notificationFilters$lambda$lambda(it) {
  return it.receivedAfter_1;
}
function notificationFilters$lambda$lambda_0(old, new_0) {
  return old.copy$default_t9hy7s_k$(new_0);
}
function notificationFilters$lambda$lambda_1(it) {
  return it.receivedBefore_1;
}
function notificationFilters$lambda$lambda_2(old, new_0) {
  return old.copy$default_t9hy7s_k$(VOID, new_0);
}
function notificationFilters$lambda$lambda_3(it) {
  return it.read_1;
}
function notificationFilters$lambda$lambda_4(old, new_0) {
  return old.copy$default_t9hy7s_k$(VOID, VOID, new_0);
}
function notificationFilters$lambda$lambda_5(it) {
  if (it == null)
    return 'All';
  return it ? 'Read' : 'Unread';
}
function notificationFilterChips$lambda$slambda$slambda() {
  return constructCallableReference((it, $completion) => orPromise($completion, function *($completion) {
    return it.copy$default_t9hy7s_k$(null);
  }), 1);
}
function notificationFilterChips$lambda$slambda($filter) {
  return constructCallableReference((it, $completion) => orPromise($completion, function *($completion) {
    yield* modify($filter, notificationFilterChips$lambda$slambda$slambda(), $completion);
    return Unit_instance;
  }), 1);
}
function notificationFilterChips$lambda$slambda$slambda_0() {
  return constructCallableReference((it, $completion) => orPromise($completion, function *($completion) {
    return it.copy$default_t9hy7s_k$(VOID, null);
  }), 1);
}
function notificationFilterChips$lambda$slambda_0($filter) {
  return constructCallableReference((it, $completion) => orPromise($completion, function *($completion) {
    yield* modify($filter, notificationFilterChips$lambda$slambda$slambda_0(), $completion);
    return Unit_instance;
  }), 1);
}
function notificationFilterChips$lambda$slambda$slambda_1() {
  return constructCallableReference((it, $completion) => orPromise($completion, function *($completion) {
    return it.copy$default_t9hy7s_k$(VOID, VOID, null);
  }), 1);
}
function notificationFilterChips$lambda$slambda_1($filter) {
  return constructCallableReference((it, $completion) => orPromise($completion, function *($completion) {
    yield* modify($filter, notificationFilterChips$lambda$slambda$slambda_1(), $completion);
    return Unit_instance;
  }), 1);
}
function notificationFilterChips$lambda(it) {
  return to(it.value_1, it.label_1);
}
function notificationFilterChips$lambda_0($this$rowOf) {
  return get_centered($this$rowOf);
}
function notificationFilterChips$lambda_1($this$rowOf, item) {
  var tmp = lens(item, notificationFilterChips$lambda$lambda);
  filterChip($this$rowOf, tmp, VOID, notificationFilterChips$lambda$slambda_2(item));
  return Unit_instance;
}
function notificationFilterChips$lambda$lambda(it) {
  return it.label_1;
}
function notificationFilterChips$lambda$slambda_2($item) {
  return constructCallableReference(($completion) => orPromise($completion, function *($completion) {
    // Inline function 'com.lightningkite.reactive.context.invoke' call
    var this_0 = $item;
    yield* (yield* await_0(this_0, $completion)).remove_94srgz_k$($completion);
    return Unit_instance;
  }), 0);
}
//region block: init
Companion_instance = new (Companion())();
//endregion
//region block: exports
export {
  NotificationFilters as NotificationFilters2kj3bq3y0683j,
  notificationFilterChips as notificationFilterChipsfj5o61l0xxdo,
  notificationFilters as notificationFilters1u2w2erv5f4mj,
};
//endregion

//# sourceMappingURL=NotificationFilters.mjs.map
